import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { VOICE_CALL_LABELS } from '../../constants/voice-call.constants';
import { CallDurationService } from '../../services/call-duration.service';
import { CallSessionService } from '../../services/call-session.service';

@Component({
  selector: 'app-voice-call-drawer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './voice-call-drawer.component.html',
  styleUrls: ['./voice-call-drawer.component.css'],
})
export class VoiceCallDrawerComponent {
  private readonly session = inject(CallSessionService);
  private readonly duration = inject(CallDurationService);

  readonly labels = VOICE_CALL_LABELS;
  readonly open = this.session.drawerOpen;
  readonly uiState = this.session.uiState;
  readonly inCall = this.session.inCall;
  readonly isStarting = this.session.isStarting;
  readonly canStart = this.session.canStart;
  readonly isMuted = this.session.isMuted;
  readonly isSpeakerOn = this.session.isSpeakerOn;
  readonly callDuration = this.duration.formatted;
  readonly transcriptLines = this.session.transcriptLines;

  constructor() {
    effect(() => {
      if (this.uiState() === 'active') {
        this.duration.start();
        return;
      }
      this.duration.stop();
    });
  }

  isActive(): boolean {
    return this.uiState() === 'active';
  }

  statusText(): string {
    return this.session.displayStatus();
  }

  close(): void {
    this.session.closeDrawer();
  }

  startCall(): void {
    void this.session.startCall();
  }

  endCall(): void {
    this.session.endCall();
  }

  toggleMute(): void {
    this.session.toggleMute();
  }

  toggleSpeaker(): void {
    this.session.toggleSpeaker();
  }
}
